<div class="forbidden-container">
    <div class="image-section">
        <img src="assets/images/forbidden/forbidden.png" alt="{{ 'forbidden.imgAlt' | translate }}" />
    </div>

    <div class="content-section">
        <h1>{{ 'forbidden.title' | translate }}</h1>
        <p>{{ 'forbidden.subtitle' | translate }}</p>

        <a class="primary-button" [routerLink]="ROUTE_CONSTANTS.HOME">
            <i-feather name="arrow-left"></i-feather>
            <span>{{ 'forbidden.home' | translate }}</span>
        </a>
    </div>
</div>
